module.exports = __webpack_public_path__ + "img/polygon.6fc62160.svg";